import React, {Component} from 'react';
import {
  Badge,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button
} from 'reactstrap';
import {Link} from 'react-router-dom';
import Grid from '../../../components/Grid/';
import {api} from '../../../constants';
import {getSurveys as APIGetSurveys} from '../../../gateways/surveys';
import {SURVEY_TYPES} from '../../../constants';

class List extends Component {

  constructor(props) {
    super(props);

    let currentPage = 1;

    this.state = {
      data: [],
      currentPage: currentPage,
      maxPage: 1,
      limit: 20,
      total: 0,
      filters: {
        name: "",
        survey_type: "",
        status: ""
      }
    };

    this.onSubmitFilters = this.onSubmitFilters.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
  }

  componentWillMount() {
    this.fetchData();
  }

  fetchData() {
    APIGetSurveys({ limit: this.state.limit, page: this.state.currentPage, ...this.state.filters })
    .then(result => {
      this.setState({
        total: result.total,
        data: result.data.surveys,
        maxPage: result.pages
      });
    });
  }

  getGridButtons(row) {
    return (
      <div>
        <Link to={'/surveys/view/' + row.id} ><Button className="btn btn-sm"><i className="fa fa-eye"></i>&nbsp;View</Button></Link>
      </div>
    );
  }

  onSubmitFilters(filters) {
    this.setState({
      currentPage: 1,
      filters: {
        name: filters.name,
        survey_type: filters.survey_type,
        status: filters.status
      }
    }, this.fetchData);
  }

  onChangePage(page) {
    this.setState({
      currentPage: page
    }, this.fetchData);
  }

  render() {
    let columns = [{
        key: "tools",
        type: "custom",
        render: (row) => this.getGridButtons(row),
        minWidth: "150px"
      },
      {
        key: "name",
        type: "string",
        name: "Name",
        minWidth: "150px"
      },
      {
        key: "survey_type",
        type: "string",
        name: "Survey Type",
        query: SURVEY_TYPES.reduce((map, surveyType) => {
          map[surveyType.key] = surveyType.name;
          return map;
        }, {}),
        minWidth: "150px"
      },
      {
        key: "status",
        type: "string",
        name: "Status",
        query: {
          "on_going": "On Going",
          "inactive": "Inactive",
          "finished": "Finished"
        },
        minWidth: "150px"
      },
      {
        key: "start_date",
        type: "datetime",
        name: "Start Date",
        minWidth: "150px"
      },
      {
        key: "end_date",
        type: "datetime",
        name: "Date Due",
        minWidth: "150px"
      }
    ];

    let filter = {
      fields: [
        {
          "id": "name",
          "text": "Name",
          "type": "text"
        },
        {
          "id": "survey_type",
          "text": "Survey Type",
          "type": "select",
          "options": SURVEY_TYPES.map((surveyType) => {
            return { value: surveyType.key, text: surveyType.name}
          })
        },
        {
          "id": "status",
          "text": "Status",
          "type": "select",
          "options": [
            { value: "inactive", text: "Inactive" },
            { value: "on_going", text: "On Going"},
            { value: "finished", text: "Finished"}
          ]
        }
      ]
    };

    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs="12">
            <Card>
              <CardBody>
                <Grid
                  columns={columns}
                  filter={filter}
                  onSubmitFilters={this.onSubmitFilters}
                  onChangePage={this.onChangePage}
                  data={this.state.data}
                  currentPage={this.state.currentPage}
                  perPage={this.state.limit}
                  total={this.state.total} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/views/Surveys/List/List.js